import styled from 'styled-components';

export const HeaderFlexWrap = styled.div`
  display: flex;
  position: relative;
  margin: 0px 5px;
  padding: 8px 5px 5px 5px;
  flex-direction: column;
  position: sticky;
  top: 0px;
  z-index: 9;
  background-color: #e9edf0;
`;

export const TitleFlexWrap = styled.div`
  flex-grow:1;
  display:flex;
  flex-direction:row;
  flex-wrap: wrap;
  align-items: center;
  padding: 0px;
  background-color: #d8e0e6;
  margin-bottom: 5px;
`;

export const ViewToggleWrapper = styled.div`
  padding: 5px;
  input:active + label, input:hover + label, label:active, label:hover {
    border-color: #ddd;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    width: 0px;
  }
  .ant-radio-button-wrapper {
    border: 1px solid #ddd;
  }
  .ant-radio-button-wrapper:focus-within {
    outline: none;
  }
`;

export const ViewerSessionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  min-height: 600px;
`;

export const VMTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  padding: 10px;
  gap: 10px;
`;

export const WarningText = styled.div`
  margin: 10px;
  font-size: 16px;
`;

